import { useSnackbar as notistackUseSnackbar, OptionsObject, VariantType } from 'notistack';
import type { ReactNode } from 'react';

export const useSnackbar = () => {
    const { enqueueSnackbar } = notistackUseSnackbar();

    const defaultOptions: OptionsObject = {
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
        },
        autoHideDuration: 10000,
        variant: 'default',
        style: { whiteSpace: 'pre-line' },
    };

    const showSnackbar = (message: ReactNode, options: VariantType | OptionsObject) => {
        if (typeof options === 'string') {
            options = {
                variant: options,
            };
        }

        enqueueSnackbar(message, {
            ...defaultOptions,
            ...options,
        });
    };

    return showSnackbar;
};
